import _ from 'lodash/fp'

export const TOOLS_KEYS = [
  "dicomEdit",
  "changePatient",
  "viewStudy",
  "viewerLink",
  "launchInHoros",
  "downloadStudy",
  "downloadCD",
  "attachNonDicom",
  "studyNotes",
  "report",
  "share",
  "markAsRead",
  "activityLogs"
]

export const TOOLS_LABELS = _.zipObject(TOOLS_KEYS,[
  "Edit DICOM",
  "Change patient",
  "View on webviewer",
  "Get webviewer link",
  "Launch with Horos",
  "Download images",
  "Download for CD",
  "Attachments",
  "Study notes",
  "Report",
  "Share",
  "Mark as read",
  "See activity logs"
])

export const TOOLS_ICONS = _.zipObject(TOOLS_KEYS,[
  "edit-line",
  "change-patient",
  "view",
  "link-thin",
  "launch",
  "download",
  "download-cd",
  "attachments",
  "study-notes",
  "report",
  "send-line",
  "unavailable",
  "activity-logs", // TODO - change the icon name here
])
